import styled, { css } from "styled-components";
import { lighten } from "polished";

export const Container = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.$columnsDesktop && css`
      display: grid;
      grid-template-columns: repeat(${props.$columnsDesktop}, 1fr);
      justify-items: stretch;
      align-items: stretch;

      @media (max-width: 480px) {
        grid-template-columns: repeat(${props.$columnsMobile || 2}, 1fr);
      }
    `}
`;

export const Option = styled.button`
  cursor: pointer;
  border: 0;
  border-radius: 4px;
  transition: 0.3s;
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.primary.lightest};
  width: ${(props) => (props.$isGrid ? '100%' : (props.$btnWidth || '200px'))};
  height: 2.5em;
  color: ${(props) => props.theme.primary.lightest};
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;

  @media (max-width: 480px) {
    height: 44px;
    font-size: 16px;
    width: ${(props) => (props.$isGrid ? '100%' : 'calc((100% - 10px) / 2)')};
    min-width: 64px;
    padding: 0 6px;
  }

  ${(props) =>
    props.$isSelected
      ? css`
          background: ${props.theme.primary.lightest} !important;
          color: white !important;
        `
      : css`
          :hover {
            background: ${lighten(0.3, props.theme.primary.lightest)};
            color: ${props.theme.primary.lightest};
            svg { color: ${props.theme.primary.lightest}; }
          }
        `}
`;
